import { render, staticRenderFns } from "./GeniusHotspot.vue?vue&type=template&id=7b2cb654&scoped=true"
import script from "./GeniusHotspot.vue?vue&type=script&lang=js"
export * from "./GeniusHotspot.vue?vue&type=script&lang=js"
import style0 from "./GeniusHotspot.vue?vue&type=style&index=0&id=7b2cb654&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2cb654",
  null
  
)

export default component.exports